export class ConfirmationModal{ 
    
    headerMessage:string;
    bodyMessage:string;

}


// WEBPACK FOOTER //
// ./src/app/modules/admin-terms-of-use/entities/confirmation-modal.ts